//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import { UPDATE_PROFILE } from "@/graphql/mutations/auth.js";
import { changePassword } from "@/utils/auth.js";
import { contextualHelp } from "@/utils/contextualHelp.js";

export default {
  name: "MyProfilePage",
  mounted() {
    EventBus.$emit("page-loaded", { page: "MyProfilePage" });
    EventBus.$emit("dynamic-help", {
      help: contextualHelp["MyProfilePage"]
    });
    let user = this.$store.getters["auth/getUser"];
    this.dni = user.username;
    this.group = user.attributes["custom:group"];
    this.user = user.internal;
  },
  computed: {
    formRules() {
      return {
        required: value => !!value || "Obligatorio",
        regex: v =>
          /^[0-9]{8,8}[A-Za-z]$/.test(v) || "DNI debe cumplir el formato"
      };
    },
    passwordRules() {
      return {
        required: value => !!value || "Obligatorio",
        min: v => v.length >= 8 || "Mínimo 8 caracteres",
        passwordMatch: () => "El usuario o contraseña no es correcto",
        regex: v =>
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(v) ||
          "Debe una minúscula, una mayúscula y un número"
      };
    }
  },
  data() {
    return {
      valid: true,
      dni: "",
      group: "",
      user: {},
      showResetPassword: false,
      passwordValid: false,
      oldPassword: "",
      newPassword: "",
      newPasswordConfirm: ""
    };
  },
  methods: {
    async changePassword() {
      let success = await this.$refs.changePasswordForm.validate();

      if (success) {
        if (this.password !== this.passwordConfirm) {
          this.$q.notify({
            position: "top-right",
            message: "Las contraseñas no coinciden",
            color: "negative"
          });
          return;
        }
        this.$q.loading.show({
          message: "Cambiando contraseña... <br/><span>Espere...</span>"
        });
        try {
          await changePassword(this.oldPassword, this.newPassword);
          this.$q.notify({
            position: "top-right",
            message: "Contraseña cambiada correctamente",
            color: "positive"
          });
          this.oldPassword = "";
          this.newPassword = "";
          this.newPasswordConfirm = "";
        } catch (e) {
          console.log(e.message);
          this.$q.notify({
            position: "top-right",
            message: e.message,
            color: "negative"
          });
        } finally {
          this.$q.loading.hide();
        }
      }
    },
    async submit() {
      let success = await this.$refs.form.validate();
      if (success) {
        this.$q.loading.show({
          message: "Actualizando perfil... <br/><span>Espere...</span>"
        });
        try {
          await this.$apollo.mutate({
            mutation: UPDATE_PROFILE,
            variables: {
              id: this.user.id,
              group: this.group,
              nombre: this.user.nombre,
              primer_apellido: this.user.primer_apellido, // this should be the same name as the one the server is expecting
              segundo_apellido: this.user.segundo_apellido // this should be the same name as the one the server is expecting
            }
          });
          this.$q.notify({
            position: "top-right",
            message: "Perfil actualizado correctamente",
            color: "positive"
          });
        } catch (e) {
          console.log(e.message);
          this.$q.notify({
            position: "top-right",
            message: e.message,
            color: "negative"
          });
        } finally {
          this.$q.loading.hide();
        }
      }
    }
  }
};
